export const cartActions = {
    LOADING: 'LOADING',
    ERROR: 'ERROR',
    GET_CART_ITEMS: 'GET_CART_ITEMS',
    POST_CART_ITEMS: 'POST_CART_ITEMS',
    UPDATE_CART_ITEMS: 'UPDATE_CART_ITEMS',
    DELETE_CART_ITEMS: 'DELETE_CART_ITEMS',
}
